

import { useState } from "react";
import Config from "../../Config";

 

import Start from "./Start";
import Group from "./Group";
import Kids from "./Kids"; 
import Free from "./Free"; 
import FreeSettings from "./FreeSettings";
import Overhour from "./Overhour";
import Hour from "./Hour";
import InOut from "./InOut";
import NoticeOnline from "./NoticeOnline";
import Arch from "./Arch";
import BookKid from "../kidsE/BookKid";
import Book from "../kidsE/Book";
import Layette from "../kidsE/Layette";
import LessonExtra from "./LessonExtra";
import FreePl from "./FreePl";




function KidsView(props)
{

 

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }



    
    var tab0 = " m_item ";
    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
    var tab6 = " m_item ";
    var tab7 = " m_item ";
    var tab8 = " m_item ";
    var tab9 = " m_item ";
    var tab10 = " m_item ";
    var tab11 = " m_item ";
    var tab12 = " m_item ";

    if(props.mainView.viewSelected == "start") tab0 = tab0 + " selected";
    if(props.mainView.viewSelected == "group") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "kid") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "free") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "over") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "hour") tab5 = tab5 + " selected";
    if(props.mainView.viewSelected == "inout") tab6 = tab6 + " selected";
    if(props.mainView.viewSelected == "online") tab7 = tab7 + " selected";
    if(props.mainView.viewSelected == "arch") tab8 = tab8 + " selected";
    if(props.mainView.viewSelected == "book") tab9 = tab9 + " selected";
    if(props.mainView.viewSelected == "layette") tab10 = tab10 + " selected";
    if(props.mainView.viewSelected == "free_pl") tab12 = tab12 + " selected";

    var subMenu = <div className="submenu">
            <div className={tab0} module="kids" view="start" id="" onClick={props.mainView.quickGo} >Szukaj</div>
            <div className={tab1} module="kids" view="group" id="" onClick={props.mainView.quickGo} >Grupy</div>
            <div className={tab2} module="kids" view="kid" id="" onClick={props.mainView.quickGo} >Dzieci</div>            
            <div className={tab3}  module="kids" view="free" id="" onClick={props.mainView.quickGo} >Nieobec. (Posiłki)</div>                       
            <div className={tab12}  module="kids" view="free_pl" id="" onClick={props.mainView.quickGo} >Nieobec. (Placówka)</div>                       
            <div className={tab11}  module="kids" view="zd" id="" onClick={props.mainView.quickGo} >Zaj. dodatkowe</div>                       
            <div className={tab6}  module="kids" view="inout" id="" onClick={props.mainView.quickGo} >Wej. i wyj.</div>
            <div className={tab5}  module="kids" view="hour" id="" onClick={props.mainView.quickGo} >Godziny</div>          
            <div className={tab4}  module="kids" view="over" id="" onClick={props.mainView.quickGo} >Nadgodz.</div>
            <div className={tab9}  module="kids" view="book" id="" onClick={props.mainView.quickGo} >Dzienniczek</div>
            <div className={tab10}  module="kids" view="layette" id="" onClick={props.mainView.quickGo} >Wyprawka</div>    
            <div className={tab7}  module="kids" view="online" id="" onClick={props.mainView.quickGo} >Zgłoszenia</div>
            <div className={tab8}  module="kids" view="arch" id="" onClick={props.mainView.quickGo} >Archiwum</div>            
        
    </div>


 
 

    if(props.mainView.viewSelected == 'start' || props.mainView.viewSelected == undefined )
    {
        document.title ="Wyszukiwarka / Dzieci"; 

        return (
            <div className="econtent ">                           
                     {subMenu}      
                  <Start  userData={props.userData}  mainView={props.mainView}  /> 
             </div>
        )
    }

    if(props.mainView.viewSelected == 'group')
    {
        document.title ="Grupy / Dzieci"; 
        return (
            <div className="econtent ">                           
                           {subMenu}      
                  <Group  userData={props.userData}  mainView={props.mainView}  /> 
             </div>
        )
    }

    if(props.mainView.viewSelected == 'kid')
    {
        document.title ="Lista dzieci / Dzieci"; 
        return (
            <div className="econtent ">                           
                             {subMenu}    
                  <Kids  userData={props.userData}  mainView={props.mainView}  /> 
             </div>
        )
    }
  

    if(props.mainView.viewSelected == 'free')
        {
            document.title ="Nieobecności na posiłkach"; 
            return (
                <div className="econtent ">                           
                    {subMenu}                         
                      <Free  userData={props.userData}  mainView={props.mainView}  /> 
                      <FreeSettings   mainView={props.mainView} userData={props.userData}  />   
                 </div>
            )
        }  


      if(props.mainView.viewSelected == 'free_pl')
        {
            document.title ="Nieobecności w placówce"; 
            return (
                <div className="econtent ">                           
                    {subMenu}                      
                      <FreePl  userData={props.userData}  mainView={props.mainView}  /> 
                 </div>
            )
        }  
        

    if(props.mainView.viewSelected == 'over')
            {
                document.title ="Nadgodziny / Dzieci"; 
                return (
                    <div className="econtent ">          
                            {subMenu}                                                      
                          <Overhour  userData={props.userData}  mainView={props.mainView}  /> 
                     </div>
                )
            }           

    if(props.mainView.viewSelected == 'hour')
                {
                    document.title ="Godziny pobytu / Dzieci"; 
                    return (
                         <div className="econtent ">    
                             {subMenu}                                                            
                              <Hour  userData={props.userData}  mainView={props.mainView}  /> 
                         </div>
                    )
                }        
                
    if(props.mainView.viewSelected == 'inout')
                    {
                        document.title ="Wejścia i wyjścia / Dzieci"; 
                        return (
                             <div className="econtent ">         
                                 {subMenu}                                                       
                                  <InOut  userData={props.userData}  mainView={props.mainView}  /> 
                             </div>
                        )
                    }   
                    
    if(props.mainView.viewSelected == 'online')
                        {
                            document.title ="Zgłoszenia OnLine"; 
                            return (
                                 <div className="econtent ">    
                                     {subMenu}                                                            
                                      <NoticeOnline  userData={props.userData}  mainView={props.mainView}  /> 
                                 </div>
                            )
                        }     
                        
      if(props.mainView.viewSelected == 'arch')
                            {
                                document.title ="Archiwum"; 
                                return (
                                     <div className="econtent ">    
                                         {subMenu}                                                            
                                          <Arch  userData={props.userData}  mainView={props.mainView}  /> 
                                     </div>
                                )
                            }           
                            
       if(props.mainView.viewSelected == 'book')
                                {
                                    document.title ="Dzienniczki"; 
                                    return (
                                         <div className="econtent employee styleGreen">    
                                             {subMenu}                                                            
                                            <Book  userData={props.userData}  mainView={props.mainView}  kid={[]}  />
                                         </div>
                                    )
                                }                                

                                                         
       if(props.mainView.viewSelected == 'layette')
                                {
                                    document.title ="Wyprawka"; 
                                    return (
                                         <div className="econtent employee styleGreen">    
                                             {subMenu}                                                            
                                            <Layette  userData={props.userData}  mainView={props.mainView}  kid={[]}  />
                                         </div>
                                    )
                                }    
                                
    if(props.mainView.viewSelected == 'zd')
                                {
                                    document.title ="Zajęcia dodatkowe"; 
                                    return (
                                         <div className="econtent employee styleGreen">    
                                             {subMenu}                                                            
                                            <LessonExtra  userData={props.userData}  mainView={props.mainView}  kid={[]}  />
                                         </div>
                                    )
                                }                                   

                                
    return (
        <div className="econtent">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );
    
}

export default KidsView ;